import { useEffect } from 'react'

import { useIntercom } from 'react-use-intercom'

import { useAppSelector } from '../store/hooks'

import MainLayout from './mainlayout/MainLayout'
import { selectProfileData } from '../store/user/userSlice'
import useIntercomUpdate from '../hooks/useIntercomUpdate'
import FirebaseApp from '../services/firebaseApp'

const AppLayout: React.FC = () => {
  let profileData = useAppSelector(selectProfileData)

  const { boot } = useIntercom()
  const { updateIntercomUser } = useIntercomUpdate()

  useEffect(() => {
    // Boot Intercom
    boot()

    // Update user data if we have an email (user is logged in)
    const email = FirebaseApp.auth.currentUser?.email
    if (email) {
      updateIntercomUser(profileData)
    }
  }, [boot, updateIntercomUser, profileData])

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  return <MainLayout />
}

export default AppLayout
